import { SearchParams, YadoRoom } from "../types";
import i18n from "../../i18n";

export const formatQuery = (query: SearchParams): Record<string, string> => {
  const formattedQuery: Record<string, string> = {
    checkinDate: query.checkinDate?.toLocaleDateString('ja-JP'),
    checkoutDate: query.checkoutDate?.toLocaleDateString('ja-JP'),
    adultCount: query.people.adult.toString(),
    childAges: query.people.children.map((child) => child.age).join(',') || '',
    areaCodes: query.areaCodes?.join(',') || '',
    skiInOut: query.skiInOut?.toString() || '',
    hotSpring: query.hotSpring?.toString() || '',
    for_stg: query.forStg?.toString() || '',
    for_hoshino_resort: query.forHoshinoResort?.toString() || ''
  };

  return Object.fromEntries(
    Object.entries(formattedQuery).filter(([_, value]) => !!value)
  );
};

export const parseUrlParamsToQuery = (search: string, defaults: SearchParams): SearchParams => {
  const params = new URLSearchParams(search);

  const checkinDate = params.get("checkinDate");
  const checkoutDate = params.get("checkoutDate");
  const adultCount = params.get("adultCount");
  const childAges = params.get("childAges");
  const areaCodes = params.get("areaCodes");
  const resortCodes = params.get("resortCodes");
  const skiInOut = params.get("skiInOut");
  const hotSpring = params.get("hotSpring");
  const forHoshinoResort = params.get("hoshinoResort");

  return {
    checkinDate: checkinDate ? new Date(checkinDate) : defaults.checkinDate,
    checkoutDate: checkoutDate ? new Date(checkoutDate) : defaults.checkoutDate,
    people: {
      adult: adultCount ? Number(adultCount) : defaults.people.adult,
      children: childAges
        ? childAges.split(',')
            .filter(age => age.trim() !== '')
            .map(age => ({ age: Number(age) }))
        : defaults.people.children,
    },
    areaCodes: areaCodes ? areaCodes.split(',') : defaults.areaCodes,
    resortCodes: resortCodes ? resortCodes.split(',') : defaults.resortCodes,
    skiInOut: skiInOut ? JSON.parse(skiInOut) : defaults.skiInOut,
    hotSpring: hotSpring ? JSON.parse(hotSpring) : defaults.hotSpring,
    forStg: defaults.forStg,
    forHoshinoResort: forHoshinoResort ? JSON.parse(forHoshinoResort) : defaults.forHoshinoResort,
  };
};

export const findRoomWithMinPrice = (rooms: YadoRoom[]) => {
  return rooms.reduce((min, room) => {
    return Math.min(...roomPlanPrices(room)) < Math.min(...roomPlanPrices(min))? room : min }, rooms[0]);
};

export  const findRoomWithMaxPrice = (rooms: YadoRoom[]) => {
  return rooms.reduce((min, room) => {
    return Math.max(...roomPlanPrices(room)) < Math.max(...roomPlanPrices(min))? room : min }, rooms[0]);
};

export  const roomPlanPrices = (room: YadoRoom): number[] => {
  return room.yado_plan.packages.map(p => Number(p.total_price.amount.replace(',', '')))
}

export const getAdultCountDisplay = (adultCount) => {
  return `${i18n.t('base.adults')} ${i18n.t('base.number_of_people.other', { count: adultCount })}`;
};

export const getChildrenCountDisplay = (childrenCount) => {
  return childrenCount > 0 ? `${i18n.t('base.children')} ${i18n.t('base.number_of_people.other', { count: childrenCount })}` : '';
};

export const getPeopleCountDisplay = (people) => {
  const adultNum = getAdultCountDisplay(people.adult);
  const childrenNum = getChildrenCountDisplay(people.children.length);

  return `${adultNum} ${childrenNum}`.trim();
};
